export const messages = {
    "wr-dashboard.search.input.hint": "Zoeken",
    "wr-dashboard.search.label.breadcrumb": "Zoekresultaten",
    "wr-dashboard.search.message.empty": "Er zijn geen items die overeenkomen met uw zoekcriteria",
    "wr-dashboard.side-bar.selected.title:plural": "{count} items geselecteerd | {count} item geselecteerd | {count} items geselecteerd",
    "wr-dashboard.side-bar.backup-type.disk": "Schijf",
    "wr-dashboard.side-bar.backup-type.file": "Bestand",
    "wr-dashboard.side-bar.backup-type.notarized": "Genotariseerde bestanden en mappen",
    "wr-dashboard.side-bar.backup-type.exchange": "Toepassing - Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "Toepassing - Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "Toepassing - Systeemstatus",
    "wr-dashboard.side-bar.backup-type.application": "Toepassing",
    "wr-dashboard.backups-table.column.name": "Naam",
    "wr-dashboard.backups-table.column.size": "Grootte",
    "wr-dashboard.backups-table.column.version": "Laatste versie",
    "wr-dashboard.backups-table.action.delete": "Verwijderen",
    "wr-dashboard.backups-table.message.no-backups": "Er zijn nog geen back-ups in de cloud",
    "wr-dashboard.backups-sidebar.label.size": "Grootte",
    "wr-dashboard.backups-sidebar.label.type": "Type",
    "wr-dashboard.backups-sidebar.label.version": "Laatste versie",
    "wr-dashboard.backups-sidebar.label.created": "Gemaakt",
    "wr-dashboard.backups-sidebar.label.machine": "Computer",
    "wr-dashboard.backups-sidebar.label.owner": "Eigenaar",
    "wr-dashboard.content-table.column.name": "Naam",
    "wr-dashboard.content-table.column.versions": "Versies",
    "wr-dashboard.content-table.column.volumes": "Volumes",
    "wr-dashboard.content-table.column.path": "Pad",
    "wr-dashboard.content-table.column.size": "Grootte",
    "wr-dashboard.content-table.column.version": "Laatste versie",
    "wr-dashboard.content-table.action.notary-verify": "Verifiëren",
    "wr-dashboard.content-table.action.notary-get-crt": "Certificaat ophalen",
    "wr-dashboard.content-table.action.asign": "Verzenden voor ondertekening",
    "wr-dashboard.content-table.action.versions": "Versies",
    "wr-dashboard.content-table.action.restore": "Downloaden",
    "wr-dashboard.content-table.label.size": "Grootte",
    "wr-dashboard.content-table.label.created": "Gemaakt",
    "wr-dashboard.content-table.label.modified": "Gewijzigd",
    "wr-dashboard.content-table.message.empty-folder": "Deze map is leeg",
    "wr-dashboard.password-dialog-box.title.backup": "Versleutelde back-up",
    "wr-dashboard.password-dialog-box.title.archive": "Versleuteld archief",
    "wr-dashboard.password-dialog-box.message.backup": "Geef het wachtwoord op om toegang te krijgen tot de back-up {displayName}",
    "wr-dashboard.password-dialog-box.message.archive": "Geef het wachtwoord op om toegang te krijgen tot het archief {displayName}",
    "wr-dashboard.password-dialog-box.hint.password": "Wachtwoord",
    "wr-dashboard.password-dialog-box.message.invalid-password": "Het wachtwoord is onjuist",
    "wr-dashboard.form.button.open": "Openen",
    "wr-dashboard.form.button.close": "Sluiten",
    "wr-dashboard.form.button.cancel": "Annuleren",
    "wr-dashboard.form.button.continue": "Doorgaan",
    "wr-dashboard.form.button.proceed": "Doorgaan",
    "wr-dashboard.form.button.delete": "Verwijderen",
    "wr-dashboard.form.button.done": "Gereed",
    "wr-dashboard.form.button.retry": "Opnieuw proberen",
    "wr-dashboard.notary.verify.view.status.downloading": "Downloaden…",
    "wr-dashboard.notary.verify.view.status.validating": "Valideren…",
    "wr-dashboard.notary.verify.view.status.pending": "Uw certificaat is in behandeling ...",
    "wr-dashboard.notary.verify.view.status.fail": "Certificaten komen niet overeen",
    "wr-dashboard.notary.verify.view.button.get-crt": "Certificaat ophalen",
    "wr-dashboard.notary.verify.view.file-info.name": "NAAM",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "ONDERTEKEND DOOR",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "DATUM VAN BACK-UP",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "DATUM VAN NOTARISATIE",
    "wr-dashboard.notary.verify.view.button.cancel": "Annuleren",
    "wr-dashboard.notary.verify.view.button.done": "Gereed",
    "wr-dashboard.notary.warning.unsupported.browser.version": "Browserversie wordt niet ondersteund",
    "wr-dashboard.versions-dialog-box.title": "Versies van {fileName}",
    "wr-dashboard.asign-dialog-box.title": "Verzenden voor ondertekening",
    "wr-dashboard.asign-dialog-box.message": "De bestandsversie wordt gedeeld, maar niemand kan het bestand bekijken zonder de link naar het bestand. Ga verder naar ASign om ondertekenaars toe te voegen en de link te delen.",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "Bestandsgegevens weergeven",
    "wr-dashboard.page-not-found.title": "Pagina niet gevonden",
    "wr-dashboard.page-not-found.message.main": "De pagina die u zoekt, is niet gevonden.",
    "wr-dashboard.page-not-found.message.description": "De link is mogelijk verouderd of u hebt een verkeerd adres getypt.",
    "wr-dashboard.page-not-found.message.error": "Foutcode: 404",
    "wr-dashboard.server-error.title": "De server is niet beschikbaar",
    "wr-dashboard.server-error.message": "De server is momenteel niet beschikbaar. Probeer het later opnieuw.",
    "wr-dashboard.server-error.message.error": "Foutcode: 500",
    "wr-dashboard.account-menu.action.sign-out": "Afmelden",
    "wr-dashboard.breadcrumb.item.machines": "Machines",
    "wr-dashboard.breadcrumb.item.failed-backups": "Mislukte back-ups",
    "wr-dashboard.machines-table.column.name": "Naam",
    "wr-dashboard.machines-table.column.size": "Grootte",
    "wr-dashboard.machines-table.message.no-machines": "Er zijn nog geen machines in de cloud",
    "wr-dashboard.incomplete-backups.message.status:plural": "Er zijn {count} mislukte of onvolledige back-ups die {size} opslagruimte in beslag nemen | Er is {count} mislukte of onvolledige back-up die {size} opslagruimte in beslag neemt | Er zijn {count} mislukte of onvolledige back-ups die {size} opslagruimte in beslag nemen",
    "wr-dashboard.incomplete-backups.button.view": "Back-ups weergeven",
    "wr-dashboard.incomplete-backups.button.delete": "Back-ups verwijderen",
    "wr-dashboard.machines-table.message.space-used:plural": "Totaal back-upgebruik: {size}",
    "wr-dashboard.delete-archive-dialog-box.title": "Archieven verwijderen",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "Onvolledige archieven verwijderen",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "Alle onvolledige archieven verwijderen",
    "wr-dashboard.delete-archive.message": "Weet u zeker dat u de geselecteerde archieven definitief wilt verwijderen uit alle locaties? Alle gegevens worden verwijderd en kunnen niet worden hersteld.",
    "wr-dashboard.certificate-pending-dialog-box.title": "Certificaat is in behandeling",
    "wr-dashboard.certificate-pending-dialog-box.message": "Probeer het over een paar minuten opnieuw.",
    "wr-dashboard.form.button.ok": "OK"
};
